import { createRequests } from "./requests";
import { getTransport } from "./transport";

/**
 * The production API surface (request-client-seam 01).
 *
 * `requests` is built once, but its transport is looked up per call through
 * `getTransport()`, so `setTransport(fake)` in a test takes effect immediately
 * without rebuilding the capabilities. Importers use this object only; the
 * old `client.ts` namespace is deleted by ticket 05.
 */
export const requests = createRequests((path, init) => getTransport()(path, init));

export { createRequests } from "./requests";
export { getTransport, setTransport, fetchTransport } from "./transport";
export type {
  CatalogsRequests,
  ContainersRequests,
  ItemsRequests,
  MediaRequests,
  Requests,
  SearchRequests,
  SessionRequests,
} from "./requests";
export type { Transport } from "./transport";
export * from "./errors";
